import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderCardAttributeTypeResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER CARD ATTRIBUTE TYPE]';
export const orderCardAttributeTypeActions =
  createBaseResourceActions<OrderCardAttributeTypeResourceTypeMappings>(
    domainSlug,
  );
